import { Component } from '@angular/core';

@Component({
  selector: 'app-entity-types',
  templateUrl: './entity-types.component.html',
  styleUrls: ['./entity-types.component.css'],
})
export class EntityTypesComponent {
  title1 = 'Admin Panel';
  title = 'Business Category <span>Master</span>';
  title2 = 'Business Sub Category <span>Master</span>';
  title3 = 'Entity <span>Master</span>';
  title4 = 'Document <span>Master</span>';
  title5 = 'Document Mapping <span>Master</span>';
  title6 = 'Add new Business Category';
  title7 = 'Add new Business Sub Category';
  title8 = 'Add new Entity';
  title9 = 'Add new Document';
  title10 = 'Add new Document Mapping';
  class1 = 'profile-banner';
  img1 = '../../../assets/images/logo.png';
  showAddModel: boolean = false;
  showAddModelB: boolean = false;
  showAddModelC: boolean = false;
  showAddModelD: boolean = false;
  showAddModelE: boolean = false;
  toggleModel() {
    this.showAddModel = !this.showAddModel;
  }
  toggleModelB() {
    this.showAddModelB = !this.showAddModelB;
  }
  toggleModelC() {
    this.showAddModelC = !this.showAddModelC;
  }
  toggleModelD() {
    this.showAddModelD = !this.showAddModelD;
  }
  toggleModelE() {
    this.showAddModelE = !this.showAddModelE;
  }
}
